<template>
  <div :class="{'container-with-titleBar':switchPoi, container:!switchPoi}">
    <TitleBar
      v-if="switchPoi"
      :show-all-pois="false"
      @poiChangeCallback="getData"
    />
    <div
      v-if="earn"
      class="overview"
    >
      <div class="description">
        {{ earn.statisticDesc }}
      </div>
      <div class="cell-box">
        <div
          v-for="(item,index) in cells"
          :key="item.prop"
          :class="{cell:true,'row-1':index<3,'cell-2':index===1}"
        >
          <div class="title">
            {{ item.title }}
          </div>
          <div class="value">
            {{ earn[item.prop] || '-' }}
          </div>
        </div>
      </div>
      <div class="description">
        注：计入排序订单量 = 可参与排序提权订单量 * 提权系数
      </div>
    </div>
    <NoData
      v-else
      tips="暂无提权收益数据"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TitleBar from '@/components/TitleBar';
import NoData from '@/components/NoData';
import MerchantApi from '@/api/merchant';
import STATUS from '@/constants/status';
import tracker from '@/util/tracker';
import { CID } from '@/constants/statistics';

export default {
  name: 'PoiEarn',
  components: {
    TitleBar,
    NoData,
  },
  data() {
    const { switchPoi } = this.$route.query;
    return {
      switchPoi,
      cells: [{
        title: '充电宝订单量',
        prop: 'orderCnt',
      }, {
        title: '可参与排序提权订单量',
        prop: 'sortOrderCnt',
      }, {
        title: '提权系数',
        prop: 'ratio',
      }, {
        title: '计入排序订单量',
        prop: 'sortEarningValue',
      }, {
        title: '提权效果',
        prop: 'earningEffect',
      }],
      earn: null,
    };
  },
  computed: {
    ...mapState({
      poiId(state) {
        if (this.switchPoi) {
          return state.currentPoi.poiId;
        } else {
          return this.$route.query.key;
        }
      },
    }),
  },
  created() {
    this.getData();
    const cid = this.switchPoi ? CID.HomeEarn : CID.FoodEarn;
    tracker.sendPV(cid);
  },
  methods: {
    async getData() {
      this.$store.commit('setLoading', true);
      await MerchantApi.getPoiEarn(this.poiId, !this.switchPoi).then((res) => {
        if (res.code === STATUS.SUCCESS && res.data) {
          this.earn = res.data;
        } else {
          this.earn = null;
        }
      }).catch(() => {
        this.earn = null;
      });
      this.$store.commit('setLoading', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 30px;
}

.overview {
  padding: 0 16px;
  text-align: center;
  letter-spacing: 0;
  .cell-box {
    display: flex;
    flex-wrap: wrap;
    margin: 16px 0;
    padding: 16px 0;
    border-radius: 12px;
    background: #FFF;

  }
}
.cell {
  min-width: 210px;
  &.row-1{
    margin-bottom:50px;
  }
  &.cell-2{
    flex: 1;
  }

  .value {
    margin-top: 16px;
    font-weight: bold;
  }
}

.description {
  padding-left: 20px;
  text-align: left;
  color:#666;
}
</style>
